import { render } from "./Enemies.vue?vue&type=template&id=6af18424"
import script from "./Enemies.vue?vue&type=script&lang=js"
export * from "./Enemies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__